import { getApiInstance } from '../api';

export const getAllPowerDistributionCompanies = async (token: string) => {
  const api = getApiInstance(token);
  try {
    const result = await api.get('/power-distribution-companies');

    return { success: true, data: result.data };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: `Erro ao carregar concessionárias. ${(error as Error).message}`,
    };
  }
};
